import PropTypes from 'prop-types';
import { ComponentType } from 'react';
import { IndexableObject } from '../types/ObjectTypes';
import createChainablePropType, {
  ChainablePropType,
} from './createChainablePropType';

export const getComponentPropType = (
  component:
    | {
        propTypes?: IndexableObject;
        defaultProps?: IndexableObject;
      }
    | ComponentType
): ChainablePropType => {
  if ('defaultProps' in component) {
    const { propTypes, defaultProps } = component;
    return createChainablePropType(PropTypes.elementType, 'componentProp', {
      propTypes,
      defaultProps,
    });
  }
  const { propTypes } = component;
  return createChainablePropType(PropTypes.elementType, 'componentProp', {
    propTypes,
  });
};

// Using an `any` type here because of how low-level this function is &
// its varied use across product apps
export const isRenderable = (children: any): boolean =>
  children != null && children !== false;
